// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"554697e9","623":"13073503"}[chunkId] + ".css";
};